const BASE_STATE_USER = {
	email: ''
}

const state = {
	user: BASE_STATE_USER
}

const getters = {
	user (state) {
		return JSON.parse(JSON.stringify(state.user))
	},
	userEmail (state) {
		return state.user.email
	},
	hasEmail (state) {
		return !!state.user.email
	}
}

const actions = {
	updateUser ({ commit }, userData ) {
		commit('setUserData', { userData })
	},
	clearUser ({ commit }) {
		commit('setUserData', { userData: BASE_STATE_USER })
	}
}

const mutations = {
	setUserData (state, { userData }) {
		state.user = userData
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
